import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { makeUrlWithLang } from '../utils/helpers';
import config from '../config';
import { createInteractionMutation } from '../api/mutations';
import {
  InteractionEventTypeEnum,
  InteractionTargetTypeEnum
} from '../graphql/types';
import { CreateInteractionMutation } from '../graphql/graphql';
import { useAnalyticLogSource } from './useAnalyticLogSource';
import { cleanHtmlExtension } from '../utils/helpers/middleware';

interface UseOrganizationHitParams {
  id: string | null | undefined;
  targetType: InteractionTargetTypeEnum;
}

export const useOrganizationHit = ({
  id,
  targetType
}: UseOrganizationHitParams) => {
  const router = useRouter();
  const analyticLogSource = useAnalyticLogSource();
  const {
    i18n: { language: lang }
  } = useTranslation();

  const asPath = cleanHtmlExtension(router.asPath);
  const { protocol, host } = config;

  const [sendAnalyticsData] = useMutation<CreateInteractionMutation>(
    createInteractionMutation,
    {
      variables: {
        targetId: id,
        targetType,
        sourceLink: makeUrlWithLang({ protocol, host, path: asPath, lang }),
        eventType: InteractionEventTypeEnum.BusinessHit,
        source: analyticLogSource
      }
    }
  );

  useEffect(() => {
    try {
      if (id) sendAnalyticsData();
    } catch (e) {
      console.log(e);
    }
  }, [id]);
};
